function H4(props) {
    return (
        <h4 className="text-2xl font-bold text-darkblue text-center">
            {props.children}
        </h4>
    )
}

export default H4